"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@seneca/errors");
/**
 * Thrown when the operation
 * @param {string} method
 * @param {string} url
 * @param {number} status
 */
class BadRequestError extends errors_1.ExtendableError {
    constructor(method, url, status, correlationId) {
        super(`Bad request - ${status}, for ${method} - ${url} - correlationId: ${correlationId}`);
        this.correlationId = correlationId;
    }
}
exports.default = BadRequestError;
